import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Servicios.css";

const SITE = "https://juanipavlovsky.com.ar";

const Servicios = () => {
  // manejadores para bloquear guardado/drag
  const blockContext = (e) => e.preventDefault();
  const blockDrag = (e) => e.preventDefault();

  return (
    <>
      <Helmet>
        <title>Servicios</title>
        <meta name="description" content="Fotografía para deporte, books personalizados, vinilos y clases." />
        <link rel="canonical" href={`${SITE}/servicios`} />
        <meta property="og:title" content="Servicios | Juani Pavlovsky" />
        <meta property="og:url" content={`${SITE}/servicios`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Inicio", "item": `${SITE}/` },
            { "@type": "ListItem", "position": 2, "name": "Servicios", "item": `${SITE}/servicios` }
          ]
        })}</script>


      </Helmet>
      <div className="servicios-container">
        <h1 className="servicios-title">Servicios</h1>

        {/* 1 - Imagen izquierda */}
        <div className="servicios-section">
          <div className="servicios-image-container">
            <Link to="/servicios/deporte"><img
              src="/images/bicicleta.jpg"
              alt="Fotografía deportiva"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            /></Link>
          </div>
          <div className="servicios-text">
            <h2>Deporte</h2>
            <p>
              Cobertura de acción en disciplinas como polo, ciclismo, running y surf.
              Enfoque profesional para capturar movimiento, intensidad y contexto.
            </p>
            <Link to="/servicios/deporte" className="servicios-btn">Ver más</Link>
          </div>
        </div>

        {/* 2 - Imagen derecha */}
        <div className="servicios-section reverse">
          <div className="servicios-image-container">
            <Link to="/servicios/books-personalizados"><img
              src="/images/ejemplo-fotolibro.png"
              alt="Books personalizados"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            /></Link>
          </div>
          <div className="servicios-text">
            <h2>Books Personalizados</h2>
            <p>
              Sesiones creativas y dirigidas para modelos, artistas o retratos personales,
              con guía de poses, iluminación y estilo.
            </p>
            <Link to="/servicios/books-personalizados" className="servicios-btn">Ver más</Link>
          </div>
        </div>

        {/* 3 - Imagen izquierda */}
        <div className="servicios-section">
          <div className="servicios-image-container">
            <Link to="/servicios/vinilos"><img
              src="/images/vinilo.jpg"
              alt="Vinilos para paredes"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            /></Link>
          </div>
          <div className="servicios-text">
            <h2>Vinilos para Paredes</h2>
            <p>
              Selección de fotografías listas para decorar: impresiones en vinilo fine art,
              curadas para hogares y espacios profesionales.
            </p>
            <Link to="/servicios/vinilos" className="servicios-btn">Ver más</Link>
          </div>
        </div>

        {/* 4 - Imagen derecha */}
        <div className="servicios-section reverse">
          <div className="servicios-image-container">
            <Link to="/servicios/clases"><img
              src="/images/clases-fotografia2.jpg"
              alt="Clases de fotografía"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            /></Link>
          </div>
          <div className="servicios-text">
            <h2>Clases de Fotografía</h2>
            <p>
              Talleres y clases particulares para todos los niveles: técnica, composición,
              edición y flujo de trabajo.
            </p>
            <Link to="/servicios/clases" className="servicios-btn">Ver más</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Servicios;
